import { View } from 'react-native';
import { IconColorByType, iconLibrary, IconProps } from './icon.helper';
import { IconType } from '@photosi/rn-components/lazy-icon/LazyIcon.types';
import { LazyIcon } from '@photosi/rn-components/lazy-icon/LazyIcon';

export const Icon = ({ size = 24, accessibilityLabel, accessible, ...props }: IconProps) => {
  const type = props.type ?? IconType.PRIMARY;
  return (
    <View style={{ width: size, height: size }} accessibilityLabel={accessibilityLabel} accessible={accessible}>
      <LazyIcon iconLibrary={iconLibrary} {...props} color={IconColorByType.get(type)} width={size} height={size} />
    </View>
  );
};
